<template>
  <div class="pedido-listado">
    <section class="pedido-steps">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link to="/pricing-home">
                <img :src="require('../../../assets/img/backspace.svg')" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h5 class="pull-left" title="Ajuda sobre o histórico de preços">
                {{ $t('pricing.competition.title') }}
              </h5>
              <router-link to="/pricing-home">
                <img class="d-none d-sm-block" :src="require('../../../assets/img/backspace.svg')">
              </router-link>
            </div>
          </div>
        </div>

        <div class="filters">
          <form class="form-filter">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.competition.market') }}</label>
                  <VueMultiselect
                    v-model="filters.pais"
                    :options="options.market"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    :custom-label="(option) => `${option}`"
                    placeholder="Seleccione un País"
                    @input="enableFilterButtons"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.competition.brand') }}</label>
                  <VueMultiselect
                    v-model="filters.brand"
                    :options="options.brand"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    :custom-label="(option) => `${option}`"
                    placeholder="Seleccione una Marca"
                    @input="enableFilterButtons"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.competition.product') }}</label>
                  <VueMultiselect
                    v-model="filters.sku_id"
                    :options="options.sku_name"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    :custom-label="(option) => `${option.sku_name}`"
                    placeholder="Seleccione un Producto"
                    @input="enableFilterButtons"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>USD / caja</label>
                  <input type="number" v-model="filters.precio_usd_caja" @input="enableFilterButtons" class="form-control" placeholder="" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>USD / kg</label>
                  <input type="number" v-model="filters.precio_usd_kg" @input="enableFilterButtons" class="form-control" placeholder="" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('pricing.competition.category') }}</label>
                  <VueMultiselect
                    v-model="filters.category"
                    :options="options.category"
                    :searchable="true"
                    :close-on-select="true"
                    :show-labels="false"
                    :custom-label="(option) => `${option}`"
                    placeholder="Seleccione una Categoria"
                    @input="enableFilterButtons"
                  />
                </div>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Fecha de importación</label>
                  <Datepicker
                    v-model="filters.import_date"
                    name="fecha-import"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    utc="preserve"
                    required
                    @input="enableFilterButtons"
                  />
                </div>
              </div>
            </div>

            <div class="row justify-content-end">
              <div class="next-btn">
                <a @click="resetFilters" href="javascript:void(0)" class="btn-white">Limpiar</a>
                <a href="javascript:void(0)" @click="filter" class="btn-green" :class="{ disabled: isLoading }">
                  {{ isLoading ? 'Buscando...' : 'Buscar' }}
                </a>
              </div>
            </div>
          </form>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div v-if="isLoading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Cargando...</span>
              </div>
            </div>

            <div v-else-if="allPrices.length === 0" class="text-center py-4">
              <p class="text-muted">No se encontraron resultados con los filtros aplicados.</p>
            </div>

            <div v-else class="confirmado mt-2">
              <table class="bg-white d-none d-sm-table" id="pedidosTable">
                <thead>
                  <tr style="background-color: #fffadc;">
                    <th class="text-center">Market</th>
                    <th class="text-center">Brand</th>
                    <th class="text-center">SKU ID</th>
                    <th class="text-center">Product</th>
                    <th class="text-center">Price Per Case (USD)</th>
                    <th class="text-center">Price Per KG (USD)</th>
                    <th class="text-center">Import Date</th>
                    <th class="text-center">Category</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in paginatedPrices" :key="`${item.id}-${index}`">
                    <td class="text-center">{{ item.pais }}</td>
                    <td class="text-center">{{ item.brand }}</td>
                    <td class="text-center">{{ item.sku_id }}</td>
                    <td class="text-center">{{ item.sku_name }}</td>
                    <td class="text-center">{{ formatCurrency(item.precio_usd_caja) }}</td>
                    <td class="text-center">{{ formatCurrency(item.precio_usd_kg) }}</td>
                    <td class="text-center">{{ formatDisplayDate(item.import_date) }}</td>
                    <td class="text-center">{{ item.category || '-' }}</td>
                  </tr>
                </tbody>
              </table>

              <div class="d-block d-sm-none mobile-card-wrapper"
                    v-for="(item, index) in paginatedPrices" :key="`mobile-${item.id}-${index}`">
                <table class="bg-white pedidosTableMobile">
                  <tr><th>Market</th><td>{{ item.pais }}</td></tr>
                  <tr><th>Brand</th><td>{{ item.brand }}</td></tr>
                  <tr><th>SKU ID</th><td>{{ item.sku_id }}</td></tr>
                  <tr><th>Product</th><td>{{ item.sku_name }}</td></tr>
                  <tr><th>Price Per Case (USD)</th><td>{{ formatCurrency(item.precio_usd_caja) }}</td></tr>
                  <tr><th>Price Per KG (USD)</th><td>{{ formatCurrency(item.precio_usd_kg) }}</td></tr>
                  <tr><th>Import Date</th><td>{{ formatDisplayDate(item.import_date) }}</td></tr>
                  <tr><th>Category</th><td>{{ item.category || '-' }}</td></tr>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12 d-flex align-items-center flex-wrap justify-content-between">
            <div class="d-flex gap-2 mb-2">
              <router-link :to="{ name: 'pricing-create-competition' }" class="btn-green">Crear</router-link>
              <button class="btn-green" @click="downloadCompetition" :disabled="isDownloading">
                {{ isDownloading ? 'Descargando...' : 'Download' }}
              </button>
              <button v-if="isPricingCoord" class="btn-green" @click="triggerUpload" :disabled="isUploading">
                {{ isUploading ? 'Subiendo...' : 'Upload' }}
              </button>
            </div>

            <nav v-if="totalPages > 1">
              <ul class="pagination mb-0">
                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                  <a class="page-link" href="#" @click.prevent="goToPage(currentPage - 1)">‹</a>
                </li>
                <li class="page-item" v-for="page in visiblePageNumbers" :key="page" :class="{ active: currentPage === page }">
                  <a class="page-link" href="#" @click.prevent="goToPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                  <a class="page-link" href="#" @click.prevent="goToPage(currentPage + 1)">›</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <input
          ref="uploadInput"
          type="file"
          accept=".xlsx,.xls"
          style="display: none;"
          @change="handleUpload"
        />
      </div>
    </section>
    <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Estados
const filters = reactive({
  pais: '',
  brand: '',
  sku_id: '',
  precio_usd_caja: '',
  precio_usd_kg: '',
  category: '',
  import_date: ''
})

const options = reactive({
  market: [],
  brand: [],
  sku_name: [],
  category: []
})

const allPrices = ref([])
const currentPage = ref(1)
const itemsPerPage = ref(10)
const filterEnabled = ref(false)
const uploadInput = ref(null)
const alert = ref(null)
const isLoading = ref(false)
const isDownloading = ref(false)
const isUploading = ref(false)
const isPricingCoord = ref(false)

// Computed
const paginatedPrices = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  return allPrices.value.slice(start, start + itemsPerPage.value)
})

const totalPages = computed(() => {
  return Math.ceil(allPrices.value.length / itemsPerPage.value)
})

const visiblePageNumbers = computed(() => {
  const maxVisible = 10
  const pages = []

  let start = Math.max(currentPage.value - Math.floor(maxVisible / 2), 1)
  let end = start + maxVisible - 1

  if (end > totalPages.value) {
    end = totalPages.value
    start = Math.max(end - maxVisible + 1, 1)
  }

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  return pages
})

// Funciones de formato
function formatCurrency(value) {
  if (value === null || value === undefined || value === '') return '-'
  
  const num = parseFloat(value)
  if (isNaN(num)) return '-'
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num)
}

function formatDisplayDate(dateString) {
  if (!dateString) return '-'
  
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  } catch (error) {
    return dateString
  }
}

function formatDateToYMD(date) {
  if (!date) return ''
  
  // Si ya es una string en formato correcto, retornar como está
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date
  }
  
  // Convertir a Date si es necesario
  const d = typeof date === 'string' ? new Date(date) : date
  
  // Verificar si es una fecha válida
  if (isNaN(d.getTime())) {
    return ''
  }
  
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  
  return `${year}-${month}-${day}`
}

// Funciones de utilidad
function showAlert(type, title, message) {
  if (alert.value) {
    alert.value.showAlert(
      type,      
      message,    
      title,      
      {
        iconSize: 35,
        iconType: 'solid',
        position: 'top right'
      }
    )
  }
}

const enableFilterButtons = () => {
  filterEnabled.value = true
}

const resetFilters = () => {
  Object.keys(filters).forEach(k => filters[k] = '')
  currentPage.value = 1
  fetchPrices()
}

// Funciones de API
const getFilterData = async () => {
  try {
    const res = await axios.get('/pricing/getCompetitionFilterData')
    const data = res.data.items
    
    options.market = data.market.map(item => item.market)
    options.brand = data.brand.map(item => item.brand)
    options.sku_name = data.sku_name
    options.category = data.category.map(item => item.category)
  } catch (error) {
    console.error('Error al obtener los datos de filtro:', error)
    showAlert('error', 'Error', 'No se pudieron cargar los datos de filtro')
  }
}

const fetchPrices = async (customFilters = null) => {
  isLoading.value = true
  
  try {
    // Usar filtros personalizados o los filtros actuales
    const filtersToUse = customFilters || { ...filters }
    
    // Formatear la fecha si existe y es necesario
    if (filtersToUse.import_date) {
      filtersToUse.import_date = formatDateToYMD(filtersToUse.import_date)
    }
    
    const payload = { filtros: filtersToUse }
    const res = await axios.post('/pricing/getCompetitionPrices', payload)
    
    allPrices.value = res.data.items || []
    
    // Resetear a la primera página si estamos en una página que ya no existe
    if (currentPage.value > totalPages.value) {
      currentPage.value = 1
    }
  } catch (error) {
    console.error('Error al obtener los precios:', error)
    showAlert('error', 'Error', 'No se pudieron cargar los precios')
    allPrices.value = []
  } finally {
    isLoading.value = false
  }
}

const filter = async () => {
  if (isLoading.value) return

  currentPage.value = 1

  // Crear una copia de los filtros para no modificar el original
  const filterPayload = { ...filters }

  // Si hay SKU seleccionado, extraer solo el sku_id
  if (filterPayload.sku_id && typeof filterPayload.sku_id === 'object') {
    filterPayload.sku_id = filterPayload.sku_id.sku_id
  }
  
  await fetchPrices(filterPayload)
}

const goToPage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

const downloadCompetition = async () => {
  if (isDownloading.value) return
  
  isDownloading.value = true
  
  try {
    const title = t('pricing.competition.title')
    const header = [
      t('pricing.competition.id'),
      t('pricing.competition.market'),
      t('pricing.competition.brand'),
      t('pricing.competition.product'),
      t('pricing.competition.sku_id'),
      t('pricing.competition.price_case_usd'),
      t('pricing.competition.price_kg_usd'),
      t('pricing.competition.category'),
      t('pricing.competition.import_date')
    ]

    // Preparar filtros para descarga
    const downloadFilters = { ...filters }
    if (downloadFilters.import_date) {
      downloadFilters.import_date = formatDateToYMD(downloadFilters.import_date)
    }
    if (downloadFilters.sku_id && typeof downloadFilters.sku_id === 'object') {
      downloadFilters.sku_id = downloadFilters.sku_id.sku_id
    }

    const response = await axios.post('/pricing/downloadCompetition', {
      filtros: downloadFilters,
      competition_title: title,
      header: header
    }, {
      responseType: 'blob'
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `competencia_${new Date().toISOString().split('T')[0]}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
    
    showAlert('success', 'Éxito', 'Archivo descargado correctamente')
  } catch (error) {
    console.error("Error al descargar datos de competencia:", error)
    showAlert('error', 'Error', 'No se pudo descargar el archivo')
  } finally {
    isDownloading.value = false
  }
}

const triggerUpload = () => {
  if (isUploading.value) return
  uploadInput.value.click()
}

const handleUpload = async (event) => {
  const file = event.target.files[0]
  if (!file) return

  isUploading.value = true
  const formData = new FormData()
  formData.append('file', file)

  try {
    const response = await axios.post('/pricing/uploadCompetitionPrices', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    if (response.data?.error === true) {
      showAlert('error', '¡Error!', response.data.message || 'Ocurrió un error al subir el archivo.')
      return
    }
    
    showAlert('success', '¡Éxito!', response.data.message || '¡Archivo subido con éxito!')

    // Limpiar el input
    if (event.target) {
      event.target.value = ''
    }

    // Recargar los datos
    await filter()
  } catch (error) {
    console.error("Error al subir el archivo:", error)
    const message = error?.response?.data?.message || 'Ocurrió un error al subir el archivo.'
    showAlert('error', '¡Error!', message)
  } finally {
    isUploading.value = false
  }
}

const loadIsPricingCoord = () => {
  try {
    const raw = sessionStorage.getItem('mccain_service_user_profile')
    if (raw) {
      const parsed = JSON.parse(raw)
      isPricingCoord.value = parsed?.Princing_profile === 'pricing_coord' || false
    }
  } catch (e) {
    isPricingCoord.value = false
  }
}

// Lifecycle
onMounted(() => {
  getFilterData()
  fetchPrices()
  loadIsPricingCoord()
})
</script>

<style scoped>
.sub-header {
  margin-top: 20px;
  margin-bottom: 20px;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.btn-green:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}

.gap-2 {
  gap: 0.5rem;
}

tbody tr:hover {
  background-color: #f8f9fa;
}
</style>